import { useForm } from 'react-hook-form';

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { SingleSelect, SingleSelectOption } from '@/modules/common';
import { ProjectBillingFormData } from '@/modules/projects';

export interface ProjectDataSelectorProps {
  name: keyof ProjectBillingFormData;
  title: string;
  placeholder: string;
  emptyMessage?: string;
  form: ReturnType<typeof useForm<ProjectBillingFormData>>;
  options: SingleSelectOption[];
  isLoading: boolean;
  isReadMode: boolean;
  searchable?: boolean;
  t: (key: string) => string;
}

export function ProjectDataSelector({
  name,
  title,
  placeholder,
  emptyMessage,
  form,
  options,
  isLoading,
  isReadMode,
  searchable,
  t,
}: ProjectDataSelectorProps) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex-1">
          <FormLabel>{title}</FormLabel>
          <FormControl>
            <SingleSelect
              name={name}
              control={form.control}
              options={options}
              placeholder={isReadMode ? t('details.tabs.info.notSelected') : placeholder}
              disabled={isReadMode || isLoading}
              loading={isLoading}
              emptyMessage={isLoading ? t('common:loading') : emptyMessage}
              searchable={searchable}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
